import React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import PropTypes from 'prop-types';
import Link from '@mui/material/Link';
import HomeIcon from '@mui/icons-material/Home';
import { Box, Typography } from '@mui/material';
import '../style/common.css';

  const BreadCrumbBar = ({label}) => {

    return (
      <>
      {label?.currentMenu=== "" ? (
        <Breadcrumbs aria-label="breadcrumb" separator="|">
        <Link underline="hover" color="inherit" href="/home">
          <HomeIcon style={{color:"#005974", width: 18, height: 18}}/>
        </Link>
        </Breadcrumbs>
      ) :
      label?.currentMenu?.isSubMenu ? (
            <Breadcrumbs aria-label="breadcrumb" separator="|">
            <Link underline="hover" color="inherit" href="/home">
              <HomeIcon style={{color:"#005974", width: 18, height: 18}}/>
            </Link>
            <Link
              underline="hover"
              className='xs-normal'
              color={"#005974"}
              href={label?.currentMenu?.route}
            >
              {label?.currentMenu?.name}
            </Link>
            <Typography 
            className='xs-normal'
            color={"#005974"}>{label?.currentMenu?.subRoutesLabel}</Typography>
          </Breadcrumbs>
          ) : (
          <Breadcrumbs separator="|" aria-label="breadcrumb">
            <Link
              underline="hover"
              sx={{ display: 'flex', alignItems: 'center' }}
              href="/home"
              // aria-label={label}
            >
              <HomeIcon style={{color:"#005974", width: 18, height: 18}}/>
            </Link>

            <Box
              underline="hover"
              className='xs-normal'
              color={"#005974"}
            >
              
              {label?.currentMenu}
            </Box>
            </Breadcrumbs>
          )}
        
        <br/>
        </>
    );


  }


  BreadCrumbBar.propTypes = {
    label: PropTypes.node.isRequired,
}


  export default BreadCrumbBar;